import { useState } from "react";

const useMessageComposer = ({ onSubmit }) => {
  const [value, setValue] = useState();
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey || event.ctrlKey || event.metaKey) {
        return false;
      } else {
        event.preventDefault();
        if (value.replace(" ", "") !== "") {
          onSubmit(value);
          setValue("");
        }
        return true;
      }
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return {
    onKeyDown: handleKeyDown,
    onChange: handleChange,
    value,
  };
};

export default useMessageComposer;
